module.exports = __webpack_public_path__ + "img/yw.c2e5e6b1.png";